<template>

    <div class="layout__container">
        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <!--{{this.customers}}-->

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">User Search</h2>
                    <UserSearch v-bind:searchParams="searchParams" v-bind:customers="customers"
                                    v-bind:loading="loading" v-bind:resultsCount="resultsCount"></UserSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="customers" style="width: 100%;"
                              v-on:row-click="editCustomer"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="emailAddress" label="Email Address" width="300">
                        </el-table-column>
                        <el-table-column prop="customerRef" label="Branch Code" width="100">
                        </el-table-column>
                        <el-table-column prop="customerName" label="Customer Name" width="300">
                        </el-table-column>
                        <el-table-column prop="branchName" label="Branch Name" width="200">
                        </el-table-column>
                        <el-table-column prop="customerName" label="Customer Name" width="200">
                        </el-table-column>
                        <el-table-column prop="branchName" label="Branch Name" width="200">
                        </el-table-column>
                        <el-table-column label="Account User" width="100">
                            <template slot-scope="props">
                                <span v-if="props.row.accountUser">Account</span>
                                <span v-else>Online</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Active User" width="100">
                            <template slot-scope="props">
                                <span v-if="props.row.abpUserId !== 0">Active</span>
                                <span v-else>Not Active</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="contact" label="Contact" width="200">
                        </el-table-column>
                        <el-table-column prop="phone" label="Phone" width="200">
                        </el-table-column>
                        <el-table-column prop="postcode" label="Postcode" width="100">
                        </el-table-column>
                        <el-table-column label="Awaiting Approval" width="100">
                            <template slot-scope="props">
                                <span v-if="props.row.awaitingApproval">Yes</span>
                                <span v-else></span>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import UserSearch from '../../../components/search/UserSearch.vue';
    import Pagination from "../../../components/Pagination";
    import {backing} from '@/mixins/Backing.js';
    import {pagination} from '@/mixins/Pagination.js';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: "customers",
        mixins: [csvDownloadHelper, backing, pagination, axios],
        props: {
            view: ''
        },
        components: {
            UserSearch,
            Pagination
        },
        data() {
            return {
                resultsCount: 0,
                customers: [],
                searchParams: {
                    freetext: '',
                    status: '',
                    top: 20,
                    pagination: 20,
                    skip: 0,
                    currentPage: 1
                },
                loading: false

            }
        },
        created() {
            this.isUserAuthorised();
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_userSearch', JSON.stringify(this.searchParams));
        },
        methods: {
            editCustomer(user) {

                // if (this.returnCookie('_role') === 'RpsBilling') {
                //     this.$router.push({
                //         name: '/billing/customers/details',
                //         params: {
                //             customer: customer
                //         },
                //         query: {
                //             ref: customer.ref,
                //         }
                //     })
                // } else {
                    this.$router.push({
                        name: '/admin/users/details',
                        query: {
                            user: user.emailAddress,
                        },
                        params: {
                            view_user: user
                        },
                    })
                // }

            },
            resultsPerPage() {
                document.getElementById('getCustomersPagination').click()

            },
            csv() {
                document.getElementById('downloadAllResults').click()
            }
        },
        created() {
        }
    };
</script>